import React, { useEffect } from 'react';
import styles from './Approve.module.css';
import { useTranslation } from 'react-i18next';
import { Button } from '@mantine/core';

const Approve = ({ toRegister, sendAgaing, email, title, back }) => {
  const { t } = useTranslation();

  const handleClick = () => {
    back && back();
  }

  useEffect(() => {
    sendAgaing();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          {title || t('approve.title')}
        </div>

        <div className={styles.description}>
          {t('approve.description', { email })}
        </div>

        <Button className={styles.button} fullWidth onClick={handleClick}>
          {t('email.change')}
        </Button>

        <div className={styles.linkToRegister} onClick={toRegister}>
          {t('enter')}
        </div>
      </div>
    </div>
  )
}

export default Approve;
